import { Redirect, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const RemoveTrailingSlashRedirect = props => {
  const {
    pathname,
    hash,
    search
  } = useLocation();
  return /*#__PURE__*/_jsx(Redirect, Object.assign({}, props, {
    to: {
      pathname: `/${pathname.split('/')[1]}`,
      search,
      hash
    }
  }));
};
export default RemoveTrailingSlashRedirect;